"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _lodash = require("lodash");
require("./InPageJumpNav.scss");
var _reactAwesomeReveal = require("react-awesome-reveal");
var _InPageJumpNavMethods = require("./InPageJumpNavMethods");
var _InPageJumpNavIcon = require("./InPageJumpNavIcon");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const InPageJumpNav = _ref => {
  let {
    pageSections,
    jumpNavTitle,
    navType
  } = _ref;
  const [navExpanded, updateNavExpanded] = (0, _react.useState)(null);
  const [activeNavItem, updateActiveNavItem] = (0, _react.useState)(0);
  const [showScrollLeft, setShowScrollLeft] = (0, _react.useState)(false);
  const [showScrollRight, setShowScrollRight] = (0, _react.useState)(false);
  const jumpNavRef = (0, _react.useRef)(null);

  // assigning each page section object with its own index property in order to update state correctly on scroll
  if (pageSections && pageSections?.length) {
    pageSections.forEach((section, index) => {
      if (section) {
        section.index = index;
      }
    });
  }
  const scrollFunct = () => {
    if (jumpNavRef?.current?.scrollLeft === 0) {
      setShowScrollLeft(false);
    } else {
      setShowScrollLeft(true);
    }
    if (jumpNavRef?.current?.clientWidth + jumpNavRef?.current?.scrollLeft === jumpNavRef?.current?.scrollWidth) {
      setShowScrollRight(false);
    } else {
      setShowScrollRight(true);
    }
  };
  (0, _react.useEffect)(() => {
    setShowScrollLeft(false);
    if (jumpNavRef?.current?.clientWidth + jumpNavRef?.current?.scrollLeft === jumpNavRef?.current?.scrollWidth) {
      setShowScrollRight(false);
    } else {
      setShowScrollRight(true);
    }
    jumpNavRef?.current?.addEventListener("scroll", scrollFunct);
    return () => {
      jumpNavRef?.current?.addEventListener("scroll", scrollFunct);
    };
  }, [jumpNavRef.current]);
  const scrollLeft = () => {
    jumpNavRef?.current?.scrollTo(jumpNavRef?.current?.scrollLeft - 60, 0);
  };
  const scrollRight = () => {
    jumpNavRef?.current?.scrollTo(jumpNavRef?.current?.scrollLeft + 60, 0);
  };
  (0, _react.useEffect)(() => {
    let sectionIndex = 0;
    function handleScroll() {
      pageSections?.forEach((section, index) => {
        const target = document.getElementById(section.link);
        if (window.scrollY > target?.offsetTop - 153) {
          sectionIndex = index;
        }
      });
      updateActiveNavItem(sectionIndex);
    }
    addEventListener("scroll", (0, _lodash.throttle)(handleScroll, 100));
    return () => {
      removeEventListener("scroll", handleScroll);
    };
  }, []);
  if (navType === "horizontal") {
    return pageSections?.length > 0 && /*#__PURE__*/_react.default.createElement("div", {
      className: `ter-jump-nav-holder ter-jump-nav-holder--horizontal`
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "ter-jump-nav ter-jump-nav--horizontal"
    }, showScrollLeft && /*#__PURE__*/_react.default.createElement("span", {
      className: "ter-jump-nav__scroll ter-jump-nav__scroll--left",
      "aria-label": "Scroll jump-nav left",
      onClick: () => scrollLeft()
    }, /*#__PURE__*/_react.default.createElement("svg", {
      className: "ter-jump-nav__scroll-icon",
      xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/_react.default.createElement("path", {
      fill: "#fff",
      d: "M15 0a2.004 2.004 0 0 1 1.41 3.42L4.83 15l11.59 11.59c.78.78.78 2.05 0 2.83s-2.05.78-2.83 0l-13-13.01c-.78-.78-.78-2.05 0-2.83l13-12.99C13.98.2 14.49 0 15 0Z"
    }))), /*#__PURE__*/_react.default.createElement("nav", {
      className: "ter-jump-nav__container",
      ref: jumpNavRef
    }, /*#__PURE__*/_react.default.createElement("ul", {
      className: "ter-jump-nav__nav"
    }, (0, _InPageJumpNavMethods.renderJumpNavItems)(pageSections, activeNavItem, navType, updateActiveNavItem))), showScrollRight && /*#__PURE__*/_react.default.createElement("span", {
      className: "ter-jump-nav__scroll ter-jump-nav__scroll--right",
      "aria-label": "Scroll jump-nav right",
      onClick: () => scrollRight()
    }, /*#__PURE__*/_react.default.createElement("svg", {
      className: "ter-jump-nav__scroll-icon",
      xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/_react.default.createElement("path", {
      fill: "#fff",
      d: "M15 0a2.004 2.004 0 0 1 1.41 3.42L4.83 15l11.59 11.59c.78.78.78 2.05 0 2.83s-2.05.78-2.83 0l-13-13.01c-.78-.78-.78-2.05 0-2.83l13-12.99C13.98.2 14.49 0 15 0Z"
    })))));
  } else {
    return pageSections?.length && /*#__PURE__*/_react.default.createElement("div", {
      className: "default-layout ter-jump-nav-holder"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: `ter-jump-nav ${navExpanded ? "ter-jump-nav--expanded" : ""}`,
      onClick: () => (0, _InPageJumpNavMethods.toggleJumpNavExpanded)(navExpanded, updateNavExpanded)
    }, /*#__PURE__*/_react.default.createElement(_reactAwesomeReveal.Fade, {
      origin: "right"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "ter-jump-nav__container"
    }, /*#__PURE__*/_react.default.createElement("nav", null, /*#__PURE__*/_react.default.createElement("ul", {
      className: "ter-jump-nav__nav"
    }, jumpNavTitle && /*#__PURE__*/_react.default.createElement("li", {
      className: "ter-jump-nav__nav-item ter-jump-nav__heading"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "ter-jump-nav__heading-icon"
    }, /*#__PURE__*/_react.default.createElement(_InPageJumpNavIcon.InPageJumpNavIcon, null)), /*#__PURE__*/_react.default.createElement("div", {
      className: "ter-jump-nav__heading-text"
    }, jumpNavTitle)), (0, _InPageJumpNavMethods.renderJumpNavItems)(pageSections, activeNavItem, navType, updateActiveNavItem)))))));
  }
};
var _default = InPageJumpNav;
exports.default = _default;
InPageJumpNav.propTypes = {
  pageSections: _propTypes.default.array.isRequired,
  jumpNavTitle: _propTypes.default.string
};
InPageJumpNav.defaultProps = {
  jumpNavTitle: "This Page"
};